// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.ContentLanguages = {
  contentLanguagesHash: null,
  error: null,
  contentLanguagesFetched: false,
};
